import ServiceCard from "./ServiceCard";

const services = [
  {
    image:
      "/images/In-Ground-Installations.jpg",
    title: "In Ground Pools",
    href: "/services/inground-pools",
    alt: "In-Ground-Installations",
  },
  {
    image:
      "/images/Above-Ground-Installations.jpg",
    title: "Above Ground Pools",
    href: "/services/above-ground-pools",
    alt: "Above-Ground-Installations",
  },
  {
    image:
      "/images/Request-Pool-Service.jpg",
    title: "Request Pool Service",
    href: "/contact",
    alt: "Request-Pool-Service",
  },
  {
    image:
      "/images/Weekly-Cleaning-Maintenance.jpg",
    title: "Cleanings / Maintenance",
    href: "/contact",
    alt: "Weekly-Cleaning-Maintenance",
  },
  {
    image:
      "/images/Salt-Chlorine-Generator.jpg",
    title: "Salt Chlorine Generator",
    href: "/services/pool-salt-chlorine-generators",
    alt: "Salt-Chlorine-Generator",
  },
  {
    image:
      "/images/Heater.jpg",
    title: "Heaters",
    href: "/services/pool-heaters",
    alt: "Heater",
  },
  {
    image:
      "/images/Automatic-Cleaners.jpg",
    title: "Automatic Pool Cleaners",
    href: "/services/automatic-pool-cleaners",
    alt: "Automatic-Cleaners",
  },
  {
    image:
      "/images/2.png",
    title: "Spa Covers",
    href: "/services/spa-covers",
    alt: "Spa-Covers",
  },
  {
    image:
      "/images/1-1.png",
    title: "Pool Stairs",
    href: "/services/pool-stairs",
    alt: "Pool-Stairs",
  },
];

export default function ServicesGrid() {
  return (
    <section className="bg-[#1e2a5e] py-14 md:py-16">
      <div className="max-w-[1400px] mx-auto px-4">
        <h1 className="text-white text-center text-xl md:text-2xl font-bold uppercase tracking-widest mb-10">
          Our Complete Line of Services
        </h1>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {services.map((service) => (
            <ServiceCard
              key={service.href + service.title}
              image={service.image}
              title={service.title}
              href={service.href}
              alt={service.alt}
            />
          ))}
        </div>
      </div>
    </section>
  );
}